/**
 * Asset manifest for the v2 landing surface.
 *
 * Crops are delivered by muse-site in design/assets-prepared/ and copied into
 * public/assets/ — never re-derived here, and the raw composites are never
 * shipped. Every app image is the screen rectangle only; the device frame is
 * drawn in CSS (Layout.jsx <Device />), which stays crisp at any DPR and
 * halves the payload.
 *
 * Every entry carries intrinsic width/height so each <img> reserves its box.
 * CLS target is 0. Bytes live under /public, so none of this enters the JS
 * bundle.
 *
 * BANNED — never placed on this site, cropped or whole:
 *   appstore-02 · its poster headline states a distance figure and a venue
 *                 that are both forbidden, and its in-app card repeats them.
 *   appstore-05 · its timeline lists the same forbidden figure and venue
 *                 alongside three more unverifiable distances.
 * The closest crossing is 800 ft, Chicago, June 2019 — that is the only
 * distance permitted on this site, and the venue in those two files is
 * fabricated. Do not crop around them and reuse the rest.
 *
 * WITHHELD pending a claims answer from muse-site:
 *   app-encounter · the Scottsdale card reads "9h 12m"; REAL_STORY_FACTS says
 *                   9.4 hours (9h 24m). Precise-but-wrong is fabricated
 *                   precision even though "nine hours apart" is approved.
 *   app-timeline  · same source composite; unverified figures.
 * Neither is exported below, so neither can be placed by accident.
 */

/** §00 Hero — the LCP element. Single gold arc converging on CHICAGO. */
export const HERO_GLOBE = {
  src: '/assets/hero-globe.webp',
  width: 890,
  height: 1296,
  alt: '',
};

/** §01 Story — the same Chicago arc, full screen. */
export const APP_GLOBE_CHICAGO = {
  src: '/assets/app-globe-chicago.webp',
  width: 640,
  height: 1392,
  alt: 'The CrossedPaths globe turned to North America, a gold arc converging on Chicago.',
};

/**
 * §02 Showcase, Exhibit 02 — the only place the gold/coral identity encoding
 * is visible, which is why the legend above the rail is mandatory.
 *
 * This crop stops at the map: no stat pair, no street address, no
 * coordinates, no numbers at all. The fuller crops exist on disk and are
 * deliberately unshipped — one carried the founders' actual street address
 * and lat/long, the other carried a "9h 12m" figure that contradicts the
 * NINE HOURS APART ledger row two sections above and cannot be traced.
 */
export const APP_ENCOUNTER_MAP = {
  src: '/assets/app-encounter-map.webp',
  width: 640,
  height: 604,
  alt: "An encounter opened on the map, with each person's location pinned and labelled by name.",
};

/** §02 Showcase. */
export const APP_GLOBE_ARCS = {
  src: '/assets/app-globe-arcs.webp',
  width: 640,
  height: 1392,
  alt: 'Several gold arcs crossing a dark dot-matrix globe, each one a moment two people were in the same place.',
};

export const APP_TIMELINE = {
  src: '/assets/app-timeline.webp',
  width: 640,
  // Re-cut: the "40 Total Crossings · 2 Years · 0.2 mi Closest" stat bar is
  // spliced out. Nothing in it was false — it is the app's real filtered
  // view — but with no filter chip visible to explain itself, it read as the
  // site contradicting its own 460 and six years, three screens below both.
  height: 1268,
  alt: 'A chronological timeline of near-misses grouped by year.',
};

export const APP_GLOBE_NASA = {
  src: '/assets/app-globe-nasa.webp',
  width: 640,
  height: 1388,
  alt: 'A night-lights view of Earth with crossing points glowing across North America.',
};

/** §03 Friend Mode. */
export const APP_CONNECTIONS = {
  src: '/assets/app-connections.webp',
  width: 640,
  height: 1392,
  alt: 'The Connections screen listing the people you have connected with, with a button to add someone.',
};

/** Nav mark, footer, favicon and OG source. */
export const ICON_CROSSING = {
  src96: '/assets/icon-crossing-96.png',
  src192: '/assets/icon-crossing-192.png',
  src512: '/assets/icon-crossing-512.png',
};

export const OG_IMAGE = {
  src: '/assets/og-fallback.jpg',
  width: 1200,
  height: 630,
};
